import { c as _c } from "react/compiler-runtime";
import { useAppSelector } from "@store/store-helper";
import { projectArchivingStateSelector, projectMembersByRoleSelector, fetchingProjectsFlagsSelector, selectedProjectManagerSelector } from "@store/projects/projects-selector";
import { InviteMemberToProject } from "@pages/project-details/project-team/invite-member-to-project";
import { currentUserSelector } from "@store/user/user-selector";
import { InfoBar } from "@components/common/info-bar/info-bar";
import { InfoBarCounts } from "@components/common/info-bar/info-bar-counts";
import { InfoBarPerson } from "@components/common/info-bar/info-bar-person";
import { GroupMembersProvider } from "@context-providers/group-members-provider";
import { ChangeManagementTrigger } from "@pages/project-details/project-overview/change-management/change-management-trigger";
import { useMemo } from "react";
import { useHasUserValidPermissionProjectLevel } from "@hooks/permission-control/use-has-user-valid-permission-project-level";
import { useCanAssignProjectRoles } from "@hooks/feature-control/use-can-assign-project-roles";
import { useMediaQueryList } from "@hooks/use-media-query";
import { UtilsTypes } from "@stellar/utils";
/** Shows the main details in project team tab */
export function TeamTabProjectDetails(t0) {
  const $ = _c(42);
  const {
    project,
    isLoading
  } = t0;
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const currentUser = useAppSelector(currentUserSelector);
  const t1 = project?.id ?? "";
  let t2;
  if ($[0] !== t1) {
    t2 = projectArchivingStateSelector(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const projectArchivingState = useAppSelector(t2);
  const selectedProjectManager = useAppSelector(selectedProjectManagerSelector);
  const {
    isUpdatingProjects
  } = useAppSelector(fetchingProjectsFlagsSelector);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = projectMembersByRoleSelector("RESOURCE_ADMIN");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const adminMembers = useAppSelector(t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = projectMembersByRoleSelector("RESOURCE_EDITOR");
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const editorMembers = useAppSelector(t4);
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = projectMembersByRoleSelector("RESOURCE_VIEWER");
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const viewerMembers = useAppSelector(t5);
  let t6;
  if ($[5] !== project) {
    t6 = {
      project
    };
    $[5] = project;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const {
    canInviteUsersToPrivateProject
  } = useHasUserValidPermissionProjectLevel(t6);
  const canAssignProjectRoles = useCanAssignProjectRoles();
  let t7;
  bb0: {
    if (!project || !currentUser) {
      t7 = false;
      break bb0;
    }
    t7 = projectArchivingState === UtilsTypes.ProjectArchivingState.active && canInviteUsersToPrivateProject;
  }
  const canInviteUsersToProject = t7;
  if (isLoading || !project || project.members.length === 0) {
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <InfoBar isLoading={true} />;
      $[7] = t8;
    } else {
      t8 = $[7];
    }
    return t8;
  }
  const isActionHidden = !canInviteUsersToProject || isScreenSmOrSmaller;
  if (!canAssignProjectRoles && isActionHidden) {
    return null;
  }
  let t8;
  if ($[8] !== isUpdatingProjects || $[9] !== selectedProjectManager.name || $[10] !== selectedProjectManager.user) {
    t8 = <ChangeManagementTrigger ariaLabel="Change project manager"><InfoBarPerson member={selectedProjectManager.user} name={selectedProjectManager.name} isLoading={isUpdatingProjects} /></ChangeManagementTrigger>;
    $[8] = isUpdatingProjects;
    $[9] = selectedProjectManager.name;
    $[10] = selectedProjectManager.user;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = !canAssignProjectRoles;
  let t10;
  if ($[12] !== t8 || $[13] !== t9) {
    t10 = {
      label: "Project Manager",
      isFlexible: true,
      content: t8,
      isHidden: t9
    };
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== adminMembers.length) {
    t11 = {
      label: "Admins",
      value: adminMembers.length
    };
    $[15] = adminMembers.length;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== editorMembers.length) {
    t12 = {
      label: "Editors",
      value: editorMembers.length
    };
    $[17] = editorMembers.length;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== viewerMembers.length) {
    t13 = {
      label: "Viewers",
      value: viewerMembers.length
    };
    $[19] = viewerMembers.length;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t11 || $[22] !== t12 || $[23] !== t13) {
    t14 = <InfoBarCounts counts={[t11, t12, t13]} />;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const t15 = !canAssignProjectRoles;
  let t16;
  if ($[25] !== t14 || $[26] !== t15) {
    t16 = {
      label: "Members",
      isFlexible: true,
      content: t14,
      isHidden: t15
    };
    $[25] = t14;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t10 || $[29] !== t16) {
    t17 = [t10, t16];
    $[28] = t10;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== project) {
    t18 = <InviteMemberToProject project={project} />;
    $[31] = project;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== isActionHidden || $[34] !== t18) {
    t19 = {
      content: t18,
      isHidden: isActionHidden
    };
    $[33] = isActionHidden;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t17 || $[37] !== t19) {
    t20 = <InfoBar items={t17} action={t19} />;
    $[36] = t17;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== project || $[40] !== t20) {
    t21 = <GroupMembersProvider project={project}>{t20}</GroupMembersProvider>;
    $[39] = project;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  return t21;
}